import { render, staticRenderFns } from "./SharedInboxWidget.vue?vue&type=template&id=2899d392&scoped=true&"
import script from "./SharedInboxWidget.vue?vue&type=script&lang=js&"
export * from "./SharedInboxWidget.vue?vue&type=script&lang=js&"
import style0 from "./SharedInboxWidget.vue?vue&type=style&index=0&id=2899d392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2899d392",
  null
  
)

export default component.exports